import { ReactNode } from "react";
import { useAppSelector } from "@/redux/hooks";
import { isSystemIntegratedSelector } from "@/redux/features/auth/authSlice";
import { Integration } from "@/types/general";

interface IntegrationGuardProps {
    slug: Integration.Components.Slug;
    children: ReactNode;
    fallback?: ReactNode;
}

export const IntegrationGuard = ({ slug, children, fallback = null }: IntegrationGuardProps) => {
    const isEnabled = useAppSelector(isSystemIntegratedSelector(slug));

    if (!isEnabled) {
        return <>{fallback}</>;
    }

    return <>{children}</>;
};
